import { render } from "./AdditionalsSummary.vue?vue&type=template&id=02478be2"
import script from "./AdditionalsSummary.vue?vue&type=script&lang=js"
export * from "./AdditionalsSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__